import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {string} State */

/** @type {State} */
const initialState = null;

/**
 * @param {State} _
 * @param {import("modules/global/generic.types").ErrorAction} param
 * @return {State}
 */
const haveError = (_, { payload }) => payload;

/**
 * @return {State}
 */
const resetState = () => initialState;

export default createReducer(initialState, {
  [types.GET_MODAL_DEALERS]: resetState,
  [types.GET_MODAL_DEALERS_FAILURE]: haveError,
});
